import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import registerbackground from "../images/registrationSuccess.PNG";
import successIcon from "../images/successIcon.png";
import downArrow from "../images/downArrow.png";

const RegistrationSuccess = () => {
    const handleClose = () => {
        window.location.href = '/'; // replace with your desired URL
    };

    return (
        <Box
            sx={{
                width: '100%',
                minHeight: '100vh',
                backgroundColor: '#f9f9f9',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                p: 2,
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    borderRadius: '16px',
                    p: { xs: 3, sm: 5 },
                    maxWidth: 700,
                    width: '100%',
                    // boxShadow: 3,
                    textAlign: 'center',
                    backgroundImage: `url(${registerbackground})`,
                    backgroundSize: '100% 100%', // stretch to fill box
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    color: '#000',

                    // For responsiveness and rounded corners
                    '@media (max-width:600px)': {
                        backgroundSize: 'cover',
                        borderRadius: '12px',
                        p: 2,
                    },
                }}
            >

                {/* Close Icon */}
                <IconButton
                    onClick={handleClose}
                    sx={{ position: 'absolute', top: 10, right: 10, color: '#000' }}
                >
                    <CloseIcon />
                </IconButton>

                {/* Check Icon */}
                <Box
                    sx={{
                        backgroundColor: '#E6FBF1',  // Light green background
                        width: 80,                   // Width of the Box
                        height: 80,                  // Height of the Box
                        mx: 'auto',                  // Center horizontally
                        display: 'flex',             // Flexbox for alignment
                        alignItems: 'center',        // Vertically center content
                        justifyContent: 'center',    // Horizontally center content
                        mb: 3,                       // Margin bottom
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', // Optional: adds a slight shadow for depth
                        backgroundImage: `url(${successIcon})`,  // Add your image URL here
                        backgroundSize: 'cover',     // Ensures the image covers the box
                        backgroundPosition: 'center', // Centers the image within the box
                    }}
                />

                {/* Main Text */}
                <Typography fontFamily='Montserrat' fontSize={30} fontWeight={700} gutterBottom>
                    Registration Successful
                </Typography>
                <Typography fontFamily='Montserrat' fontSize={18} fontWeight={400} sx={{ mb: 10 }}>
                    Thanks for your interest! We'll contact you soon!
                </Typography>

                {/* App Store Section */}
                <Typography fontFamily='Montserrat' fontSize={18} fontWeight={400} sx={{ mb: 3 }}>
                    Available on
                </Typography>
                <Box
                    component="img"
                    src={downArrow}
                    alt="Down Arrow"
                    sx={{
                        width: { xs: '25px', sm: '30px', md: '35px' },
                        height: { xs: '25px', sm: '30px', md: '35px' },
                        mb: 3
                    }}
                />

                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                    <a
                        href="https://apps.apple.com/in/app/ind-matrimony/id6741297825"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                            alt="App Store"
                            style={{ height: 40, marginRight: 10 }}
                        />
                    </a>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.indmatrimony.ind_matrimony"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                            alt="Google Play"
                            style={{ height: 40 }}
                        />
                    </a>
                </Box>

                {/* Bottom Highlight */}
                <Typography
                    fontWeight={600}
                    fontSize={20}
                    fontFamily='Montserrat'
                    sx={{
                        background: 'linear-gradient(90.07deg, #FF7705 39.28%, #E60000 99.93%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        display: 'inline-block',
                    }}
                >
                    Don’t miss out, install the app and get started!
                </Typography>
            </Box>
        </Box>
    );
};

export default RegistrationSuccess;
